const getSetupAccountSteps = (parentModule, routes = []) =>
  routes.map(({ component, path, module, ...rest }) => ({
    ...rest,
    module: `${parentModule}.${module}`,
    initModule: module,
  }))

export { getSetupAccountSteps }
